import useFeatureModels from "ai-management/feature-models/hooks/useFeatureModels";
import useServerText from "util/serverText";
const useLlmFeatures = () => {
  const { data: featureModels, isLoading } = useFeatureModels();
  const serverText = useServerText();
  return {
    data: featureModels.map(({ feature_id, display_name }) => ({ id: feature_id, title: serverText(display_name) })),
    isLoading
  };
};
export default useLlmFeatures;
